<script lang="ts">
  import FirmImage from "../../assets/icons/firm.svg";
  import MediumImage from "../../assets/icons/medium.svg";
  import SoftImage from "../../assets/icons/soft.svg";

  import BodyTypeIImage from "../../assets/icons/i.svg";
  import BodyTypeXImage from "../../assets/icons/x.svg";
  import BodyTypeYImage from "../../assets/icons/y.svg";

  import { t } from "../../stores/translations";

  const imageMapping = {
    x: BodyTypeXImage,
    y: BodyTypeYImage,
    i: BodyTypeIImage,
    hard: FirmImage,
    medium: MediumImage,
    soft: SoftImage,
  };

  export let questionSlug: string;
  export let answerSlug: string;
</script>

<div class="container">
  {#if imageMapping[answerSlug]}
    <img src={imageMapping[answerSlug]} alt="chip-icon" />
  {/if}

  <span>{$t(`advice.chips.${questionSlug}.${answerSlug}`)}</span>
</div>

<style lang="scss">
  @import "src/lib/styles/variables.scss";

  .container {
    width: fit-content;
    background-color: $color-secondary;
    display: flex;
    align-items: center;
    padding: 0.25rem 0.75rem;
    border-radius: 16px;

    & > img {
      height: 21px;
    }

    & > span {
      margin-left: 0.5rem;
      color: $color-primary;
      font-size: $font-size-medium;
      line-height: 1.5rem;
      white-space: nowrap;
    }
  }
</style>
